import { render, staticRenderFns } from "./RegistryHomeLogos.vue?vue&type=template&id=1a9ab74e&"
import script from "./RegistryHomeLogos.vue?vue&type=script&lang=js&"
export * from "./RegistryHomeLogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports